var level2Task2 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <variables>
    <variable id="FM%$R0M2Y@ntRAr^FBc^">is_it_raining</variable>
  </variables>
  <block type="variables_set" id="Ep{TX=pD5PL9(YFCz.31" x="13" y="12">
    <field name="VAR" id="FM%$R0M2Y@ntRAr^FBc^">is_it_raining</field>
    <value name="VALUE">
      <block type="logic_boolean" id="[vriYQl]Z!nD=2kuqB=B">
        <field name="BOOL">TRUE</field>
      </block>
    </value>
    <next>
      <block type="text_print" id="8)(M#SE(9/X]]lg1Fa8(">
        <value name="TEXT">
          <block type="variables_get" id="EZti.tmA(n|gC%~zYG$e">
            <field name="VAR" id="FM%$R0M2Y@ntRAr^FBc^">is_it_raining</field>
          </block>
        </value>
      </block>
    </next>
  </block>
</xml>`
export default level2Task2